import React from "react";

/**
 * WishireLogo
 * dark=false → light backgrounds (navbar, login, signup) — SVG image
 * dark=true  → dark backgrounds (sidebars) — text wordmark (no white box)
 * size: "sm" | "md" | "lg" | "xl"
 * wordOnly: text-only (mobile bars)
 */
export default function WishireLogo({
  dark = false,
  size = "md",
  wordOnly = false,
  className = "",
}) {
  const textSize = { sm: "text-xl", md: "text-2xl", lg: "text-3xl", xl: "text-4xl" }[size] || "text-2xl";
  const dotSize  = { sm: "w-1.5 h-1.5", md: "w-2 h-2", lg: "w-2.5 h-2.5", xl: "w-3 h-3" }[size] || "w-2 h-2";

  // Dark sidebars or word-only → clean text wordmark
  if (dark || wordOnly) {
    return (
      <span className={`inline-flex items-center gap-1 ${className}`}>
        <span className={`font-display font-bold tracking-tight leading-none ${textSize}`}>
          <span style={{ color: "#C2410C" }}>Wis</span>
          <span className={dark ? "text-white" : "text-stone-900"}>hire</span>
        </span>
        <span className={`${dotSize} rounded-full bg-[#C2410C] shrink-0`} />
      </span>
    );
  }

  // Light backgrounds → use the actual cropped SVG (4:1 aspect ratio, clean)
  const imgH = { sm: "h-8", md: "h-10", lg: "h-12", xl: "h-14" }[size] || "h-10";

  return (
    <span className={`inline-flex items-center ${className}`}>
      <img
        src="/logo.svg"
        alt="Wishire"
        className={`${imgH} w-auto object-contain`}
        draggable={false}
      />
    </span>
  );
}

export function WishireWordmark({ dark = false, size = "md", className = "" }) {
  const textSize = { sm: "text-xl", md: "text-2xl", lg: "text-3xl", xl: "text-4xl" }[size] || "text-2xl";
  return (
    <span className={`font-display font-bold tracking-tight leading-none ${textSize} ${className}`}>
      <span style={{ color: "#C2410C" }}>Wis</span>
      <span className={dark ? "text-white" : "text-stone-900"}>hire</span>
    </span>
  );
}

export function WishireIcon({ size = 36, className = "" }) {
  return (
    <img
      src="/logo.svg"
      alt="Wishire"
      className={`object-contain ${className}`}
      style={{ height: size, width: "auto" }}
      draggable={false}
    />
  );
}
